import logoImage from './../../images/crowcloud.png';

export default class LoginController {

	static get $inject(){
		return [
			'$state', '$stateParams',
			'AlertsService','AuthService'
		];
	}

	constructor($state, $stateParams,
	            AlertsService, AuthService){

		this.data = {
			uid: $stateParams['uid'],
			token: $stateParams['token'],
			new_password1: '',
            new_password2: ''
		};
		this._$state = $state;
		this._AuthService = AuthService;
		this.addAlert = AlertsService.add.bind(AlertsService);
	}

	// --- VM Helpers -----------------


	//$scope.accessKey = $stateParams.accessKey;

	// --- VM Helpers -----------------

	submit(){
		this._AuthService.resetPassword(this.data)
			.then(()=>{ this._$state.go('^.login'); })
			.catch(r =>  this.addAlert(r));
	};


	get logoImage(){
		return logoImage;
	}
}












/** WEBPACK FOOTER **
 ** ./src/guest/resetPassword/controller.js
 **/